import * as React from 'react';
import { ControlFacet } from '../models/controls/ControlFacet';

export interface ISimpleIconProps {
  ariaLabel?: string;
  key?: string;
  title?: string;
}

export interface ISimpleIconRender {
  (props?: ISimpleIconProps): JSX.Element;
}

export interface IFabricOptimizerOverrides {
  /**
   * Given a (font glyph) icon name and optional CSS class name, returns a stateless render function for an optimized Icon
   */
  getSimpleIcon?: (iconName: string, className?: string) => ISimpleIconRender;
  /**
   * Given the onClick handler, returns JSX for the Share Hero Command
   */
  renderShareHero?: (onClick: (event: React.MouseEvent<HTMLButtonElement>) => void) => JSX.Element;
  /**
   * Returns JSX for a context menu button
   */
  renderMenuHero?: () => JSX.Element;
  /**
   * Replaces an array of Fabric Signals with cheaper equivalents, where possible
   */
  replaceSignals?: (signals?: React.ReactNode[]) => React.ReactNode[] | undefined;
}

/**
 * Control point which may be used to obtain cheaper equivalents of Fabric components
 */
export const fabricOptimizerControl: ControlFacet<{}, IFabricOptimizerOverrides> = new ControlFacet('fabricOptimizer');
